// extracted by mini-css-extract-plugin
export default {"navlink":"navbar_navlink__dpzTM","selected":"navbar_selected__0l3XC","container":"navbar_container__W-NNx"};